module.exports = __webpack_public_path__ + "fonts/HalisR-Regular.81605f62.otf";